import {Injectable} from '@angular/core';
import {SyncTable} from '../sync.table';
import {CdTemporaryMeasure} from '../../interfaces/care/cd-execution-proof/cd-temporary-measure';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {CdTemporaryMeasureFactory} from '../../factories/care/cd-execution-proof/cd-temporary-measure-factory';

@Injectable({
  providedIn: 'root'
})
export class CdTemporaryMeasuresTable extends SyncTable<CdTemporaryMeasure> {
  constructor() {
    super(db.cdTemporaryMeasures);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<CdTemporaryMeasure>({
        api: ['care', 'temporary-measures'],
        fromObject: CdTemporaryMeasureFactory.fromObject,
        toRemote: CdTemporaryMeasureFactory.toRemote
      })
    };
  }

  /**
   *
   * @param cdCarePlanId
   */
  public async getByCdCarePlanId(cdCarePlanId: number): Promise<CdTemporaryMeasure[]> {
    return this.table.where('cdCarePlanId').equals(cdCarePlanId).toArray();
  }

}
